export default __webpack_public_path__ + "static/media/logo-troyacare.1c79fd9c.svg";